module.exports = __webpack_public_path__ + "static/media/sterilis_logo.ac75ca7a.png";